import React from "react"

import Box, { BoxProps } from "./box"

export default function Column(props: Omit<BoxProps, "flexDirection">) {
  return (
    <Box
      {...props}
      alignItems={props.alignItems || "center"}
      justifyContent={props.justifyContent || "flex-start"}
      flexDirection="column"
    />
  )
}
